export const getalltechnicalfeedback =`
query allSelectedCandidatesWithFeedback {
  allSelectedCandidatesWithFeedback{
  					id
            jobid
            candidateName
            screeningStatus
            source
            mobileNumber
            emailid
            department
            totalExperience
            relevantExperience
            currentCtc
            expectedCtc
            leadTime
            yearOfPassing
            currentEmployer
            location
            comments
            position
            interviewAvailability
            interviewer
            cvFile
            manuallyAdd
            technicalFeedback{
              id
              comments
              hiringStatus
              professionalism
              technicalSkills
              levelOfInterest
              learningAbility
              confidence
              attitude
              communication
            }
    }
}

`

export const getallrecruitmentprocess = `
query allRecruitmentAndHiredFeedback {
 
  allRecruitmentAndHiredFeedback {
 
    recruitmentProcess {
 
      staffRequest{
 
        id
 
      }
 
      id
 
      payslipFile
 
      offerLetter
 
      offerSalary{
       ctc
        id
 
        basicPercentage
 
      date
 
        salaryStructure{
 
          id
 
          structureName
 
        }
 
        branch{
 
          id
 
          branchName
 
          branchCode
 
          address1
 
          address2
 
          pincode
 
          country
 
          state
 
          city
 
          gstNumber
 
          panNumber
 
          ifscCode
 
        }
 
      }
 
      onBording
 
      assertRequest
 
      documentVerification
 
      appointmentLetter
 
      appointmentLetterInstance{
 
        id
        empCode
        ctc
        basicPercentage
        salaryStructure{
          id
          structureName
        }
        date
 
      }
 
      nda
 
      hrInduction
       teamIntro
      technicalInduction
      screening
      assestHandover
 
      hrmsAccess
 
      handoverToManager
 
      technicalInterview
 
    }
 
    technicalFeedback {
 
      id
 
      hiringStatus
     employeeAddress
 
      sourcingScreening {
 
        id
 
        candidateName
 
        jobid
        department
        position
        location
 
      }

 
    }
    staffRequest{
      id
      jobid
    }
 
  }
 
}

`

export const  getprocedureorreport =`
query procedureAndReportsListall {
 
  procedureAndReportsListall{
 
    recruitmentProcess {
 
      staffRequest{
 
        id
 
      }
 
      id
 
      payslipFile
 
      offerLetter
 
      offerSalary{
 
       ctc
 
        id
 
        basicPercentage
 
      date
 
        salaryStructure{
 
          id
 
          structureName
 
        }
 
        branch{
 
          id
 
          branchName
 
          branchCode
 
          address1
 
          address2
 
          pincode
 
          country
 
          state
 
          city
 
          gstNumber
 
          panNumber
 
          ifscCode
 
        }
 
      }
 
      onBording
 
      assertRequest
 
      documentVerification
 
      appointmentLetter
 
      appointmentLetterInstance{
 
        id
 
        empCode
 
        ctc
 
        basicPercentage
 
        salaryStructure{
 
          id
 
          structureName
 
        }
 
        date
 
      }
 
      nda
 
      hrInduction
 
       teamIntro
 
      technicalInduction
 
      screening
 
      assestHandover
 
      hrmsAccess
 
      handoverToManager
 
      technicalInterview
 
    }
 
    technicalFeedback {
 
      id
 
      hiringStatus
 
     employeeAddress
 
      sourcingScreening {
 
        id
 
        candidateName
 
        jobid
 
        position
 
      }

 
 
    }
 
    staffRequest{
 
      id
 
      jobid
 
    }
 
  }
 
}
`

export const getalldepartment = `
query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }

`

export const getjobids =`
query {
  allStaffRequests {
    id
    jobid
    requestDate
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
  }
}
`

export const getstaffrequestviajobid = `
query {
    allStaffRequests {
      id
      jobid
     
    }
  }
`